/**
 * Function to be used to validate a Panel Number.
 * A Panel Number must conform with the UTP2 device regular expression.
 * @param panelNumber The Panel Number
 * @returns True if the Panel Number is valid, otherwise returns false.
 */
export function validPanelNumber(panelNumber: string): boolean {
  const regex = /^[0-9]{1,2}[A]?$/;
  return regex.test(panelNumber);
}
